import { common } from "./common";
import { nav } from "./nav";
import { footer } from "./footer";
import { auth } from "./auth";
import { gamification } from "./gamification";
import { home } from "./home";
import { settings } from "./settings";
import { pages } from "./pages";

/**
 * The English resource.
 *
 * This file is the *source of truth for key names* — every other language is
 * typed as a `DeepPartial` of it, so a key that only exists in `vi.ts` is a
 * compile error and a key missing from `vi.ts` is a silent English fallback
 * rather than a broken UI. `npm run i18n:check` reports the fallback count so
 * the gap stays visible in review.
 */
export const en = {
  common,
  nav,
  footer,
  auth,
  gamification,
  home,
  settings,
  pages,
} as const;

export type TranslationResource = typeof en;
export default en;